const breakpoints = {
  sm: '600px',
  md: '900px',
  lg: '1200px',
  xl: '1536px',
};

export default breakpoints;
